<template>
    <div class="timeline-tag-list">
        <blogpost-tag :active="currentId===''">全部</blogpost-tag>
        <template v-for="item in tagList">
            <blogpost-tag :key="item.id"
                          :id="item.id"
                          :active="item.id===currentId"
            >{{item.description}}
            </blogpost-tag>
        </template>
    </div>
</template>

<script>
    import BlogpostTag from '@components/BlogpostTag'

    export default {
        name: "TimelineTagList",
        props: {
            tagList: {
                type: Array,
                default() {
                    return []
                }
            },
            current: {
                type: Object,
                default() {
                    return {}
                }
            }
        },
        computed: {
            currentId() {
                const {current} = this
                const {id} = current || {}
                return id || ''
            }
        },
        components: {
            BlogpostTag
        }
    }
</script>

<style lang="scss">
    @import "@assets/styles/varibles.scss";

    .timeline-tag-list {
        padding: $paddingMD 0 $paddingBase 0;
    }
</style>